export enum NetworkError {
  IRW_COOKIE_MISSING = 'irw_cookie_missing',
  CART_NOT_FOUND = 'cart_not_found',
  LINE_NOT_FOUND = 'line_not_found',
  NO_ACCESS = 'no_access',
}
export enum Provider {
  IRW = 'irw',
}
